// Helper de tracking centralizado para el embudo.
//
// IMPORTANTE: es una capa ADITIVA y SOLO del lado del cliente. No reemplaza ni
// modifica los eventos estándar existentes (PageView, ViewContent,
// InitiateCheckout, Purchase) ni su lógica de CAPI dedicada. Provee un único
// punto de envío para los NUEVOS eventos del embudo (click-cta con section,
// wallet_ready, wallet_closed, wallet_error) y los reenvía a las MISMAS
// plataformas de cliente que ya usa el proyecto:
//   - GA4    → window.gtag('event', ...) (o dataLayer como fallback)
//   - Meta   → window.fbq('trackCustom', ...)
//
// DECISIÓN: por ahora NO se envían estos eventos al servidor. Mantenemos el
// backend minimalista y evitamos complejidad innecesaria. Si en el futuro
// aparece una necesidad real (CAPI / reporting), se implementará un endpoint
// específico con un caso de uso definido. Por eso este helper NO hace ningún
// fetch a /api/track.
//
// Nunca lanza: cualquier fallo de instrumentación se loguea pero no rompe el
// flujo de la landing.

type TrackParams = Record<string, unknown>

export function trackEvent(event: string, params: TrackParams = {}): void {
  try {
    if (typeof window === 'undefined') return

    const w = window as any

    // ---- Cliente: Google Analytics 4 ----
    if (typeof w.gtag === 'function') {
      w.gtag('event', event, params)
    } else {
      // Fallback a dataLayer si gtag aún no estuviera listo
      w.dataLayer = w.dataLayer || []
      w.dataLayer.push({ event, ...params })
    }

    // ---- Cliente: Meta Pixel (evento personalizado, no interfiere con los estándar) ----
    if (typeof w.fbq === 'function') {
      w.fbq('trackCustom', event, params)
    }
  } catch (err) {
    console.error(`trackEvent("${event}") falló:`, err)
  }
}
